import { useEffect, useState } from "react";
import { DEFAULT_CONFIG, fetchConfig } from "@/lib/api";

export function useConfig() {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    fetchConfig().then((c) => {
      setConfig(c);
      setLoaded(true);
    });
  }, []);
  return { config, loaded };
}
